import {
  MONTHLY,
  MONTHLY_HASH_TAG,
} from '../../../common/components/PricingTemplate';

export const pricingPlans = (t) => ({
  [MONTHLY]: {
    hashTag: MONTHLY_HASH_TAG,
    payAsGo: {
      price: 0,
      header: {
        name: t("pricing.payAsGo.header")
      },
      data: [
        20,
        "100",
        t("pricing.payAsGo.data.charges"),
        true,
        true,
        true,
        t("pricing.payAsGo.data.support")
      ],
      link: {
        "text": t("pricing.payAsGo.link")
      }
    },
    starter: {
      price: 15,
      header: {
        name: t("pricing.starter.header")
      },
      data: [
        t("pricing.starter.data.workflow"),
        "1,000",
        t("pricing.starter.data.charges"),
        true,
        true,
        true,
        t("pricing.starter.data.support")
      ],
      link: {
        "text": t("pricing.starter.link")
      }
    },
    standard: {
      price: 25,
      header: {
        name: t("pricing.standard.header")
      },
      data: [
        t("pricing.standard.data.workflow"),
        "10,000",
        t("pricing.standard.data.charges"),
        true,
        true,
        true,
        t("pricing.standard.data.support")
      ],
      link: {
        "text": t("pricing.standard.link"),
      },
      noFreeDays: true,
      mostPopular: true,
    },
    advance: {
      price: 45,
      header: {
        name: t("pricing.advance.header")
      },
      data: [
        t("pricing.advance.data.workflow"),
        t("pricing.advance.data.runs"),
        t("pricing.advance.data.charges"),
        true,
        true,
        true,
        t("pricing.advance.data.support")
      ],
      link: {
        "text": t("pricing.standard.link"),
      },
      noFreeDays: true,
    },
    enterPrice: {
      price: 65,
      header: {
        name: t("pricing.enterPrice.header")
      },
      data: [
        t("pricing.enterPrice.data.workflow"),
        t("pricing.enterPrice.data.runs"),
        t("pricing.enterPrice.data.charges"),
        true,
        true,
        true,
        t("pricing.enterPrice.data.support")
      ],
      link: {
        "text": t("pricing.standard.link"),
      },
      noFreeDays: true
    },
  }
})
